export const API_URL = 'https://your-energy.b.goit.study/api';
